import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PoolIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pool"}/>
}
